import React from 'react';

function Homepage() {
    return <div style={{backgroundColor: "black"}}/>
}

export default Homepage;
